import { useCallback, useMemo, useState } from 'react';

import type { NBranches } from '@app/types/Branches';

import type { ChangeEvent } from 'react';

export const useSetBranchesComponent = (
  allBranches: NBranches.ModelBranchItem[]
) => {
  const [searchValue, setSearchValue] = useState('');

  const searchQuery = searchValue.trim().toLowerCase();
  const isSearchApplied = searchQuery.length > 0;

  const filteredBranches = useMemo(() => {
    if (!searchQuery) {
      return allBranches;
    }
    return allBranches.filter(({ Name }) =>
      Name?.toLowerCase().includes(searchQuery)
    );
  }, [allBranches, searchQuery]);

  const searchChangeHandler = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setSearchValue(e.target.value);
    },
    []
  );

  const resetSearch = useCallback(() => {
    setSearchValue('');
  }, []);

  return {
    searchValue,
    filteredBranches,
    isSearchApplied,
    searchChangeHandler,
    resetSearch,
  };
};
